import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["data-theme"]
const _hoisted_2 = {
  key: 1,
  class: "ui-kit-view__links"
}
const _hoisted_3 = { class: "ui-kit-view__branding" }
const _hoisted_4 = { class: "ui-kit-view__branding-tabs" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "caption-navbar" }

import UiKitMain from "@/components/ui-kit/UiKitMain.vue";
import { computed, ref } from "vue";
import { allBrands, BRANDS_CONFIG, TypeBrand } from "@/config/brands";
import { useRoute } from "vue-router";
import { useRouter } from "vue-router";
import UiKitIcon from "@/components/ui-kit/UiKitIcon.vue";
import BaseFigureForIcon from "@/components/base/BaseFigureForIcon.vue";
import UiKitBrands from "@/components/ui-kit/UiKitBrands.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'UiKitView',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const tabsBrands = ref<TypeBrand[]>(allBrands);
const testSelectBrands = ref<TypeBrand>("atom");

const toggleTabsBrands = (item: TypeBrand) => {
  testSelectBrands.value = item;
};
const typeQuery = computed(() => route.query.type);
const testConfigDataBrand = computed(
  () => BRANDS_CONFIG[testSelectBrands.value]
);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: "ui-kit-view",
    "data-theme": testSelectBrands.value
  }, [
    (typeQuery.value)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 0,
          to: "/ui-kit"
        }, {
          default: _withCtx(() => [
            _createVNode(BaseFigureForIcon, {
              icon: "arrow",
              position: "left",
              "is-button": "",
              class: "ui-kit-view__prev"
            })
          ]),
          _: 1
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[2] || (_cache[2] = _createElementVNode("p", null, "Links:", -1)),
          _createVNode(_component_router_link, {
            class: "ui-kit-view__links-item",
            to: "?type=icon"
          }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createTextVNode(" Icons and Colors ")
            ])),
            _: 1,
            __: [0]
          }),
          _createVNode(_component_router_link, {
            class: "ui-kit-view__links-item",
            to: "?type=brands-config"
          }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createTextVNode(" BrandsConfig ")
            ])),
            _: 1,
            __: [1]
          })
        ])),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabsBrands.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: _normalizeClass(["ui-kit-view__branding-tabs__item", { '--active': testSelectBrands.value == item }]),
            onClick: ($event: any) => (toggleTabsBrands(item))
          }, [
            _createElementVNode("p", _hoisted_6, _toDisplayString(item), 1)
          ], 10, _hoisted_5))
        }), 128))
      ])
    ]),
    (typeQuery.value === 'icon')
      ? (_openBlock(), _createBlock(UiKitIcon, { key: 2 }))
      : _createCommentVNode("", true),
    (typeQuery.value === 'brands-config')
      ? (_openBlock(), _createBlock(UiKitBrands, {
          key: 3,
          testConfigDataBrand: testConfigDataBrand.value
        }, null, 8, ["testConfigDataBrand"]))
      : (_openBlock(), _createBlock(UiKitMain, { key: 4 }))
  ], 8, _hoisted_1))
}
}

})